/**
 * @file コンポーネント：フル動画ページスレッドポップアップ新規作成、編集ページ スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledButtonList = styled.ul`
    display: flex;
    justify-content: flex-end;
    align-items: center;
`;

export const StyledButtonListItem = styled.li`
    margin-right: 16px;

    &:last-child {
        margin-right: 0;
    }
`;

export const StyledContainer = styled.div``;

export const StyledFormList = styled.dl`
    margin-bottom: 16px;
`;

export const StyledFormListDetail = styled.dd`
    margin-bottom: 16px;

    &:last-of-type {
        margin-bottom: 0;
    }
`;

export const StyledFormListTerm = styled.dt`
    display: flex;
    align-items: center;

    &.is-required {
        &::after {
            margin-left: 4px;
            color: #c31a1e;
            content: "*";
        }
    }
`;

export const StyledFormListTermLabel = styled.label`
    display: block;
    color: #000000;
    font-size: 14px;
    line-height: 18px;
`;
